import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=0be631ee&scoped=true&"
import script from "./Traceability.vue?vue&type=script&lang=js&"
export * from "./Traceability.vue?vue&type=script&lang=js&"
import style0 from "./Traceability.vue?vue&type=style&index=0&id=0be631ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be631ee",
  null
  
)

export default component.exports